import React__default, { Fragment } from 'react';
import { useIsKeyHeld } from './useIsKeyHeld.es.js';

const visuallyHidden = "_visually-hidden_1swvj_1";
const styles = {
	visuallyHidden: visuallyHidden
};

const VisuallyHidden = (props) => {
  const isAltKeyHeld = useIsKeyHeld("Alt");
  if (isAltKeyHeld) {
    return React__default.createElement(Fragment, null, props.children);
  }
  return React__default.createElement("span", { className: styles.visuallyHidden, "data-testid": "visually-hidden" }, props.children);
};

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.es.js.map
